export default "__VITE_ASSET__b7d43006__"